import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;

const AssetPlacesService = {
    list: async (data) => axios.post(API_URL + "/assetPlaces/list", data).then(({data}) => data).catch((err) => { throw err }),
    get: async (id) => axios.get(API_URL + `/assetPlaces/${id}`).then(({data}) => data).catch((err) => { throw err }),
    create: async (data) => axios.post(API_URL + `/assetPlaces`, data).then(({data}) => data).catch((err) => { throw err }),
    update: async (id, data) => axios.post(API_URL + `/assetPlaces/${id}`, data).then(({data}) => data).catch((err) => { throw err }),
    destroy: async (id) => axios.delete(API_URL + `/assetPlaces/${id}`).then(({data}) => data).catch((err) => { throw err }),
    hasAssociated: async (id) => axios.get(`${API_URL}/assetPlaces/${id}/has-associated`).then(({data}) => data).catch((err) => {throw err}),
}

export default AssetPlacesService;
